/**
 * User-facing product identity. Code identifiers (`@dwx/*`, file names,
 * Azure resource names) are deliberately NOT renamed — see the Wave 1
 * production plan, decision D7.
 */
export const PRODUCT_NAME = 'FirstIQ Deployment Manager';

/** Full FirstIQ Productivity Suite logo, drawn for light backgrounds. */
export const LOGO_URL = '/firstiq-logo.svg';
